import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

interface IChevronDownIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
  color?: string;
}

const ChevronDownIcon = ({
  width = styleConfigs.dimensions.width20,
  height = styleConfigs.dimensions.height20,
  color = COLORS.ebonyClay,
  ...props
}: IChevronDownIconProps): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0004 14.1005C9.8057 14.1009 9.61701 14.0331 9.46708 13.9088L4.46708 9.74218C4.1127 9.44762 4.06419 8.92156 4.35874 8.56718C4.6533 8.21279 5.17936 8.16429 5.53374 8.45884L10.0004 12.1922L14.4671 8.59218C14.6392 8.45237 14.86 8.38695 15.0806 8.41041C15.3011 8.43387 15.5032 8.54428 15.6421 8.71718C15.7964 8.89039 15.8715 9.12007 15.8493 9.35097C15.8272 9.58188 15.7098 9.7931 15.5254 9.93384L10.5254 13.9588C10.3712 14.0634 10.1863 14.1133 10.0004 14.1005Z"
      fill={color}
    />
  </svg>
);

export default ChevronDownIcon;
